import { Nullable } from "shared/lib/typeCheck.lib";

export const parseJSONLikeString = <T>(input: Nullable<string>): T | null => {
  if (!input) return null;

  try {
    // Replace single quotes with double quotes to make the input JSON-compliant
    const jsonCompatibleString = input.replace(/'/g, '"');
    const parsedObject = JSON.parse(jsonCompatibleString);
    return parsedObject as T;
  } catch (_) {
    return null;
  }
};
